import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';
// Sin los datos del idioma, moment.locale('es') no surte efecto y las fechas
// salen en inglés.
import 'moment/locale/es';
import './i18n';
import { handleCorruptedLocalStorage } from './utils/validateStorageOnBoot';

//import './scss/main.sass';

moment.locale('es');

handleCorruptedLocalStorage();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
